import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';

import { withApiKey } from '@/app/helpers/auth.context';

/** Lo que el cliente completa en el formulario de soporte. */
export interface SupportTicketRequest {
  /** El numero tal como lo ve en su correo: `ORD-041696`. El backend tolera las variantes. */
  orderNumber: string;
  requesterName: string;
  requesterPhone: string;
  description: string;
  requesterEmail?: string;
  /** Hasta 5 imagenes. */
  files?: File[];
}

/**
 * Respuesta del backend.
 *
 * Trae el numero de ticket y NADA de la orden, a proposito: el endpoint es
 * publico y todo lo que conteste sobre una orden es algo que cualquiera podria
 * pedir con un numero al azar.
 */
export interface SupportTicketResponse {
  number: string;
  message: string;
}

@Injectable({ providedIn: 'root' })
export class SupportService {
  private http = inject(HttpClient);

  /**
   * Abre un ticket de soporte a nombre del cliente.
   *
   * Va como `multipart/form-data` porque lleva imagenes. NO se pone el header
   * `Content-Type` a mano: el navegador tiene que armarlo el, con el `boundary`
   * que separa las partes. Escribirlo rompe el envio de una forma que despues
   * cuesta encontrar, porque el pedido sale igual y el backend recibe vacio.
   */
  createTicket(data: SupportTicketRequest): Observable<SupportTicketResponse> {
    const form = new FormData();
    form.append('orderNumber', data.orderNumber);
    form.append('requesterName', data.requesterName);
    form.append('requesterPhone', data.requesterPhone);
    form.append('description', data.description);
    if (data.requesterEmail) form.append('requesterEmail', data.requesterEmail);

    for (const file of data.files ?? []) {
      form.append('files', file, file.name);
    }

    return this.http.post<SupportTicketResponse>('/support-web/ticket', form, {
      context: withApiKey(),
    });
  }
}
